import React from 'react'
import "./Loader.css"

const GraphLoader = ({ content = "Loading Data" }) => {
  return (
    <div className="graph-loader">
      {content}
      <span className="dots"></span>
    </div>
  );
};

export default GraphLoader